import { useSelector } from '@redux';
import crudSelectors from '@redux/crudSelectors';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ViewBatchGroupButton = ({ onCancel, handleCreate, loading }) => {
  const { t } = useTranslation();

  const selectedRowKeys = useSelector<any[]>(
    crudSelectors.transferOrders.getSelectedRowKeys,
  );

  return (
    <div className="flex justify-end items-center gap-2.5">
      <Button className="h-[40px] w-[100px]" onClick={onCancel}>
        {t('button.cancel')}
      </Button>
      <Button
        className="h-[40px] w-[100px]"
        type="primary"
        onClick={() => handleCreate(selectedRowKeys)}
        loading={loading}
        disabled={selectedRowKeys.length <= 0}
      >
        {t('button.create')}
      </Button>
    </div>
  );
};

export default ViewBatchGroupButton;
